import axios from "axios";
axios.defaults.withCredentials = true;
axios.interceptors.request.use((request) => {
  let token = localStorage.getItem("token");
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
});

axios.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (err) => {
    try {
      if (
        err.response.status === 401 &&
        !window.location.pathname.includes("login")
      ) {
        localStorage.clear();
        window.location = "/login";
      } else {
        return err.response;
      }
    } catch (error) {
      return Promise(error);
    }
    return Promise(err);
  }
);
